<template>
    <div>
        <div>
            <el-dialog :title="mainTitle" :visible.sync="editVisible" width="600px" @close="closeEdit" @open="dlgOpen" @closed="dlgClosed" :close-on-click-modal="false" :modal-append-to-body="false">
                <el-form ref="roleForm" :model="roleForm" :rules="rules" :style="dlgBody" label-width="120px" v-loading="loading">
                    <el-form-item label="系统分类" prop="systemId">
                        <el-select v-model.trim="roleForm.systemId" placeholder="请选择系统分类" style="width:90%" clearable disabled>
                            <el-option v-for="item in systemData" :key="item.value" :label="item.key" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属平台" prop="type">
                        <el-select v-model.trim="roleForm.type" placeholder="请选择所属平台" style="width:90%" disabled>
                            <el-option v-for="item in operateType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色编号" prop="code">
                        <el-input v-model.trim="roleForm.code" placeholder="请输入角色编号" clearable style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称" prop="name">
                        <el-input v-model.trim="roleForm.name" placeholder="请输入角色名称" clearable style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item label="角色管理员" prop="roleAdmin">
                        <el-radio-group v-model="roleForm.roleAdmin">
                            <el-radio :label="false">否</el-radio>
                            <el-radio :label="true">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="角色数据等级" prop="roleRange">
                        <el-select v-model.trim="roleForm.roleRange" placeholder="请选择角色数据等级" style="width:90%" clearable>
                            <el-option v-for="item in roleRangeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色描述" prop="remark">
                        <el-input type="textarea" v-model.trim="roleForm.remark" placeholder="请输入角色描述" style="width:90%" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="权限设置" prop="mobile">
                        <el-tree :props="defaultProps" node-key="id" :data="returnData" accordion :expand-on-click-node="false" ref="powerTree" :show-checkbox="true" :default-expanded-keys="showKeyArray" :default-checked-keys="defaultCheckedKeys" :highlight-current="true" @highlight-current="true" :default-expand-all="true" :check-strictly="isCascade" v-loading="loading" element-loading-text="拼命加载中...">
                            <span class="custom-tree-node" slot-scope="{ node, data }" style="font-size:14px;">
                                <!-- <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span> -->
                                <span v-if="data.parentId==0">
                                    <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                                <span v-else-if="data.parentId==1">
                                    <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                                <span v-else>
                                    <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                            </span>
                        </el-tree>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="resetForm('roleForm')">取 消</el-button>
                    <el-button type="primary" @click="onSubmit('roleForm')" :disabled="btnDisabled">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import DialogResize from "@/utils/DialogResize.js";
import SettingApi from "@/api/setting.js";
export default {
    mixins: [DialogResize],
    data () {
        return {
            loading: false,
            btnDisabled: false,
            roleRangeList: [
                {
                    value: 20,
                    label: "所属公司/部门"
                },
                {
                    value: 21,
                    label: "所在公司/部门"
                },
                {
                    value: 40,
                    label: "个人级"
                }
            ],
            operateType: [
                {
                    value: "1",
                    label: "Web"
                },
                {
                    value: "2",
                    label: "App"
                }
            ],
            defaultProps: {
                children: "subs",
                label: "name",
                isLeaf: "leaf"
            },
            isCascade: true,
            defaultCheckedKeys: [],
            showKeyArray: [],
            returnData: [],
            systemData: [],
            isShowApproval: false,
            enableStatus: "",
            operateFlag: "",
            platformType: "",
            search_Type: "",
            mainTitle: "",
            editVisible: false,
            systemType: "",
            roleForm: {
                id: "",
                code: "",
                name: "",
                roleRange: "",
                remark: "",
                systemId: "",
                roleAdmin: false
            },
            rules: {
                code: [
                    { required: true, message: "角色编号不能为空", trigger: "change" },
                    {
                        min: 1,
                        max: 30,
                        message: "角色编号输入不能超过30个字符，请重新输入",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
                        message: "不允许输入空格等特殊符号"
                    }
                ],
                name: [
                    { required: true, message: "角色名称不能为空", trigger: "change" },
                    {
                        min: 1,
                        max: 30,
                        message: "角色名称输入不能超过30个字符，请重新输入",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
                        message: "不允许输入空格等特殊符号"
                    }
                ],
                roleRange: [
                    {
                        required: true,
                        message: "角色数据等级不能为空",
                        trigger: "change"
                    }
                ],
                roleAdmin: [
                    {
                        required: true,
                        message: "角色管理员不能为空",
                        trigger: "change"
                    }
                ],
                remark: [
                    { required: true, message: "角色描述不能为空", trigger: "change" },
                    {
                        min: 1,
                        max: 255,
                        message: "角色描述输入不能超过255个字符，请重新输入",
                        trigger: "blur"
                    }
                    // {
                    //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
                    //   message: "不允许输入空格等特殊符号"
                    // }
                ],
                systemId: [
                    { required: false, message: "系统ID不能为空", trigger: "change" }
                ]
            }
        };
    },
    methods: {
        init (row, operateFlag, platformType, systemType) {
            this.loading = false;
            this.btnDisabled = false;
            this.initSystemData();
            this.onloadGroup(systemType);
            this.platformType = platformType;
            if (operateFlag == "add") {
                this.isCascade = false;
                this.mainTitle = "新增角色";
                this.operateFlag = "add";
                this.roleForm = {
                    id: "",
                    code: "",
                    name: "",
                    roleRange: "",
                    remark: "",
                    type: platformType,
                    systemId: systemType,
                    roleAdmin: false
                };
            }
            if (operateFlag == "update") {
                this.isCascade = true;
                this.mainTitle = "编辑角色";
                this.operateFlag = "update";
                // this.roleForm = {
                //   id: row.id,
                //   code: row.code,
                //   name: row.name,
                //   roleRange: row.roleRange,
                //   remark: row.remark,
                //   type: platformType,
                //   systemId: row.systemId
                // };
                this.getDataById(row.id, systemType);
            }
            this.editVisible = true;
        },
        onSubmit (formName) {
            this.$refs[formName].validate(valid => {
                // if (
                //   this.$refs.powerTree.getCheckedNodes() &&
                //   this.$refs.powerTree.getCheckedNodes().length > 0
                // ) {
                if (valid) {
                    this.loading = true;
                    var v = this.roleForm;
                    let param = {
                        id: v.id,
                        code: v.code,
                        name: v.name,
                        roleRange: v.roleRange,
                        remark: v.remark,
                        type: v.type,
                        systemId: v.systemId,
                        roleAdmin: v.roleAdmin
                    };
                    // this.$mhttp.httpPost(
                    //   this.$constant.API_NSC + "uc/role/saveOrUpdate",
                    //   param,
                    //   "application/json"
                    // );

                    SettingApi.getClass()
                        .saveRole(param)
                        .then(res2 => {
                            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                                if (
                                    this.$refs.powerTree.getCheckedNodes() &&
                                    this.$refs.powerTree.getCheckedNodes().length > 0
                                ) {
                                    this.onSubmitPower(res2.data.data.id, false);
                                } else {
                                    this.onSubmitPower(res2.data.data.id, true);
                                    this.loading = false;
                                    this.editVisible = false;
                                    this.$parent.initData();
                                }
                            } else {
                                this.loading = false;
                                this.$message.error(res2.data.msg);
                                return false;
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                            return false;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
                // } else {
                //   this.$message({
                //     showClose: true,
                //     message: "请选择一条记录",
                //     type: "warning",
                //     duration: 2000
                //   });
                //   return;
                // }
            });
        }, //清空表单验证
        resetForm (formName) {
            this.$refs["roleForm"].resetFields();
            this.editVisible = false;
            this.defaultCheckedKeys = [];
        },
        closeEdit () {
            this.$refs["roleForm"].resetFields();
            this.editVisible = false;
            this.defaultCheckedKeys = [];
        },
        initSystemData () {
            // this.$mhttp.httpGet(
            //   this.$constant.API_NSC + "uc/system/systems",
            //   null,
            //   null
            // );

            SettingApi.getClass()
                .loadSystems()
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        let obj = {};
                        this.systemData = [];
                        for (let i = 0; i < data.length; i++) {
                            obj = {
                                value: data[i].id,
                                key: data[i].name
                            };
                            this.systemData.push(obj);
                        }
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },
        getDataById (id, systemType) {
            this.loading = true;
            this.btnDisabled = true;
            // this.$mhttp.httpGet(this.$constant.API_NSC + "uc/role/" + id, null, null);

            SettingApi.getClass()
                .getRoleById(id)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.loading = false;
                        this.btnDisabled = false;
                        let data = res2.data.data;
                        this.roleForm = {
                            id: data.id,
                            code: data.code,
                            name: data.name,
                            roleRange: data.roleRange,
                            remark: data.remark,
                            type: this.platformType,
                            systemId: systemType,
                            roleAdmin: data.roleAdmin
                        };
                        this.$nextTick(() => {
                            this.getPowerData(id);
                        });
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
        },
        onloadGroup (systemType) {
            let param = {
                catalog: systemType
            };
            // this.$mhttp
            //   .httpGet(
            //     this.$constant.API_NSC + "uc/right/rights/catalog",
            //     param,
            //     null
            //   )
            SettingApi.getClass()
                .onloadRightGroup(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        if (res2.data.data != null) {
                            this.returnData = res2.data.data;
                            this.showKeyArray = [];
                            this.showKeyArray.push(res2.data.data.id);
                            if (this.parentId == "" || this.parentId == null) {
                                this.parentId = res2.data.data[0].id;
                                this.parentName = res2.data.data[0].name;
                                this.$nextTick(() => {
                                    this.$refs.powerTree.setCurrentKey(res2.data.data[0].id);
                                });
                            } else {
                                this.$nextTick(() => {
                                    this.$refs.powerTree.setCurrentKey(this.parentId);
                                });
                            }
                        } else {
                            this.returnData = [];
                        }
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        handleNodeClick (data, node, vuecomponent) {
            // console.log(
            //   "data:",
            //   data,
            //   "\n",
            //   "node:",
            //   node,
            //   "\n",
            //   "vuecomponent",
            //   vuecomponent
            // );
            // this.parentId = data.id;
            // this.parentName = data.name;
            this.$refs.powerTree.setCheckedKeys([data.id]);
        },
        onSubmitPower (roleId, clearAble) {
            this.loading = true;
            this.btnDisabled = true;
            let callData = {};
            callData = this.$refs.powerTree
                .getCheckedNodes()
                .concat(this.$refs.powerTree.getHalfCheckedNodes());
            let param = {
                roleId: roleId,
                roleRightDtos: [],
                clearAble: clearAble
            };
            for (let i = 0; i < callData.length; i++) {
                let dtos = {};
                dtos.roleId = roleId;
                dtos.rightId = callData[i].id;
                param.roleRightDtos.push(dtos);
            }
            SettingApi.getClass()
                .saveRightInRole(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.$message.success("保存成功！");
                        this.loading = false;
                        this.btnDisabled = false;
                        this.editVisible = false;
                        this.$parent.initData();
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
            // } else {
            //   this.$message({
            //     showClose: true,
            //     message: "请选择一条记录",
            //     type: "warning",
            //     duration: 2000
            //   });
            //   return;
            // }
            this.defaultCheckedKeys = [];
            this.$refs.powerTree.setCheckedKeys([]);
            this.editVisible = false;
        },
        getPowerData (roleId) {
            // this.$mhttp.httpGet(
            //   this.$constant.API_NSC + "uc/right/roleRights/" + roleId,
            //   null,
            //   null
            // );
            this.loading = true;
            this.btnDisabled = true;
            SettingApi.getClass()
                .getRightDataByRoldId(roleId)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.loading = false;
                        this.btnDisabled = false;
                        if (res2.data.data != null) {
                            let data = res2.data.data;
                            for (let i = 0; i < data.length; i++) {
                                this.defaultCheckedKeys.push(data[i].rightId);
                            }
                            this.$refs.powerTree.setCheckedKeys(this.defaultCheckedKeys);
                        }
                        this.isCascade = false;
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
        }
    }
};
</script>
<style scoped>
.operate {
    color: rgb(206, 23, 48);
}
.operate-unline {
    color: rgb(102, 121, 129);
}
.operate-o {
    color: rgb(83, 185, 92);
}
.icon-sea {
    margin: -10px;
    margin-left: 10px;
}
</style>
